import React,{Component} from 'react'

import {
  Hidden
} from 'material-ui'

import Fade from 'material-ui/transitions/Fade'

import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  // Legend,
  Label,
  Tooltip
} from 'recharts'

import UnauthorizedText from './UnauthorizedText'

import {
  Accent,
  Primary,
} from '../helper/consts'

export default class DashboardMonthActivityAreaChart extends Component{
  render(){
    const {data,title} = this.props;
    return(
      !!data?
        <Fade in={true}>
            <div>
            <Hidden only={['xs','sm',]}>
              <AreaChart width={420} height={420} data={data} >
                <XAxis padding={{left: 30, right: 30}} interval={7} allowDecimals={false} dataKey="name">
                  <Label offset={-10} position="bottom" />
                </XAxis>
                <YAxis width={10} allowDecimals={false} domain={[0, 'dataMax + 1']} />
                <Tooltip/>
                <Area type='monotone' dataKey={title} stroke={Accent} fill={Primary} />
              </AreaChart>
            </Hidden>
            <Hidden only={['md','lg','xl']}>
              <AreaChart width={280} height={280} data={data} >
                <XAxis padding={{left: 30, right: 30}} interval={7} allowDecimals={false} dataKey="name">
                  <Label offset={-10} position="bottom" />
                </XAxis>
                <YAxis width={10} allowDecimals={false} domain={[0, 'dataMax + 1']} />
                <Tooltip/>
                <Area type='monotone' dataKey={title} stroke={Accent} fill={Primary} />
              </AreaChart>
            </Hidden>
          </div>
        </Fade>
      :
        <div className="noData">
          <UnauthorizedText subText='Not Enough Data' />
        </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/DashboardMonthActivityAreaChart.js